// extracted by mini-css-extract-plugin
export default {"inputCommon":"style_inputCommon__pKYP0"};